import PropTypes from "prop-types";
import React, { useState } from "react";

import API from "Signups/API.js";
import { getSignedUpViaID } from "Signups/SharedComponents/getSignedUpViaID";
import { getSignupErrorMessage } from "Signups/SharedComponents/getSignupErrorMessage";
import { useSignups } from "Signups/state";
import { useShowPollFields } from "Signups/stateHooks";

import FnrButton from "UI/FnrButton3";

import { checkForAnyPaidRespondents } from "./utils/checkForAnyPaidRespondents";
import { getUserSignupItem } from "./utils/getUserSignupItem";

CancelPollSignupButton.propTypes = {
  signupItemID: PropTypes.number,
};

export default function CancelPollSignupButton({ signupItemID }) {
  const [state, dispatch] = useSignups();
  const [status, setStatus] = useState(null);
  const userSignupItem = getUserSignupItem(state.userSignupItems, signupItemID);
  const [, setShowPollFields] = useShowPollFields();

  const hasAnyPaidRespondents = checkForAnyPaidRespondents(userSignupItem);

  const closeItem = () => {
    dispatch({
      type: "expandedItemID",
      ID: null,
    });
  };

  const handleCancelClick = () => {
    if (status === "loading") return;
    setStatus("loading");

    const signedUpViaID = getSignedUpViaID();
    const emailOrPhone = state.user.emailOrPhone || null;

    API.cancelSignupForItem2({ signupItemID, signedUpViaID, emailOrPhone })
      .post()
      .then((resp) => {
        dispatch({
          type: "Item Signup Updated",
          userSignupItems: resp.userSignupItems,
          newCounts: resp.itemSlotsTaken,
          cancelled: true,
          paymentAmountNeeded: 0,
        });

        dispatch({
          type: "removeOldVoteFromSlotsTaken",
          payload: { oldVoteItemID: Number(signupItemID) },
        });

        setShowPollFields(true);
        setStatus(null);
        closeItem();
      })
      .catch((err) => {
        alert(getSignupErrorMessage(err.error));
        setStatus(null);
        closeItem();
      });
  };

  if (hasAnyPaidRespondents) return <div />;

  return (
    <FnrButton
      text="Cancel Vote"
      onClick={handleCancelClick}
      loading={status === "loading"}
    />
  );
}
